export default "__VITE_ASSET__M4Z1da8b__"